// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kc-0";
export var fileCarousel = "_kc-2";
export var removeFileButton = "_kc-1";